<template>
  <tr>
     <td class="number">{{player.num}}</td>
     <td>{{player.name}}</td>
     <td>{{player.ref_roster_line}}</td>
     <td>{{player.M}}</td>
     <td>{{player.F}}</td>
     <td>{{player.Ag}}</td>
     <td>{{player.Ar}}</td>
     <td>
         <span v-for="skill in player.skills" >
           {{skill.name}},
         </span>
     </td>
     <td>
         <span v-if="player.upgrades.length" v-for="up in player.upgrades" :class="getUpgradeStyle(up)" >
            {{getUpgradeName(up)}},
         </span>
         <span v-if="player.downgrades" class="upgrade down">
            {{getDowngrades(player)}},
         </span>
         <div v-if="player.customizations && player.customizations.length" v-for="cust in player.customizations" class="upgrade stats">
             <span v-if="cust.skills" v-for="skill in cust.skills">{{skill.name}}, </span>
         </div>
     </td>
     <td>{{player.total_xp}}</td>
     <td>
        <span class="additional_skills">{{player.base_cost + player.evolution_cost}}k</span>
     </td>
     <td>
      {{season_break_info.played_seasons + season_break_info.custom.custom_played_seasons}}
    </td>
    <template v-if="mode === 'read'">
       <td>
     {{season_break_info.is_leaving_roll}}
   </td>
   <td>
     <div v-if="season_break_info.is_leaving === false">Non</div>
     <div v-else>Oui</div>
   </td>
   <td>
     {{season_break_info.niggling_cancelling}}
   </td>
   <td>
     <span v-if="season_break_info.is_leaving === true" class="additional_skills">
       {{player.base_cost + player.evolution_cost + (season_break_info.played_seasons + season_break_info.custom.custom_played_seasons) * 20}}k
     </span>
     <span v-else class="additional_skills">{{player.base_cost + player.evolution_cost}}k</span>
   </td>
     </template>
    <template v-if="mode === 'write' ">
      <td class="left-button">
        <button class="row_button" @click="played_season_offset++">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
      </td>
      <td>
        <button class="row_button" @click="played_season_offset--">
          <i class="fa fa-minus" aria-hidden="true"></i>
        </button>
      </td>
      <td>{{season_break_info.played_seasons + played_season_offset}}</td>
    </template>
  </tr>
</template>

<script>

export default {
  name: 'player-sbi-line',
  props: {
    'player': {},
    'season_break_info': {},
    'mode': ''
  },
  data () {
    return {
      played_season_offset: this.season_break_info.custom.custom_played_seasons
    }
  },
  methods: {
    getUpgradeName (upgrade) {
      if (upgrade.status === 0) {
        return ''
      }
      if (upgrade.value === 0 || upgrade.value === 1) {
        return upgrade.skill
      }
      if (upgrade.value === 2) {
        return '+1 M'
      }
      if (upgrade.value === 3) {
        return '+1 Ar'
      }
      if (upgrade.value === 4) {
        return '+1 Ag'
      }
      if (upgrade.value === 5) {
        return '+1 F'
      }
    },
    getUpgradeStyle (upgrade) {
      if (upgrade.type === 0) {
        return 'upgrade base'
      }
      if (upgrade.type === 1) {
        if (upgrade.value === 0) {
          return 'upgrade simple'
        }
        if (upgrade.value === 1) {
          return 'upgrade double'
        }
        if (upgrade.value > 1) {
          return 'upgrade stats'
        }
      }
    },
    getDowngrades (player) {
      if (player.downgrades === null) {
        return ''
      }
      let dwngrd = ''
      if (player.downgrades['M'] !== 0) {
        dwngrd += '-' + player.downgrades['M'].toString(10) + 'M '
      }
      if (player.downgrades['F'] !== 0) {
        dwngrd += '-' + player.downgrades['F'].toString(10) + 'F '
      }
      if (player.downgrades['Ag'] !== 0) {
        dwngrd += '-' + player.downgrades['Ag'].toString(10) + 'Ag '
      }
      if (player.downgrades['Ar'] !== 0) {
        dwngrd += '-' + player.downgrades['Ar'].toString(10) + 'Ar '
      }
      return dwngrd
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .left-button {
    padding: 0;
  }

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.7rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
}

.roster tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size:0.6rem;
}

.upgrade {
  font-weight: 600;
}

.stats {
  color: #882e8e
}

.down {
  color: #8e2625
}
.row_button {
  padding: 0.4rem;
  font-weight: 600;
  font-size: 1rem;
  margin: 0.4rem;
}


</style>



// WEBPACK FOOTER //
// player-season-break-line.vue?3846604d